import * as React from 'react';

import { DOMAINS } from 'bundles/ent-website/constants/navigation';

export type EntWebsiteDomain = keyof typeof DOMAINS;

export type EntWebsiteDomainContextState = {
  domain: EntWebsiteDomain;
};

export const EntWebsiteDomainContext = React.createContext<EntWebsiteDomainContextState>({
  domain: DOMAINS.c4b,
} as EntWebsiteDomainContextState);

export const EntWebsiteDomainProvider: React.LegacyFunctionComponentWithChildren<EntWebsiteDomainContextState> = ({
  children,
  domain,
}) => {
  return <EntWebsiteDomainContext.Provider value={{ domain }}>{children}</EntWebsiteDomainContext.Provider>;
};

export type PropsFromWithEntWebsiteDomainContext = {
  entWebsiteDomainContext: EntWebsiteDomainContextState;
};
